import React, { useEffect, useRef } from 'react';
import { getFramework, HOTKEY_TYPE, useIdentity } from '@/framework';
import { IExportPlugin, PluginType } from '@/version-types';
import { checkScaleKeydown } from './utils';

const StageScale = React.memo(() => {
    const identity = useIdentity();
    const wheelY = useRef<number>(0);

    useEffect(() => {
        const framework = getFramework(identity);

        // 滚轮缩放
        const wheelHandle = framework.events.onWheel((ev) => {
            const isDisablePick = framework.operate.isDisablePick();
            const isShowContextMenu = framework.getShowContextMenu();
            if (isDisablePick || isShowContextMenu) return;
            const isScaleKeyDown = ev.ctrlKey || checkScaleKeydown();
            if (!isScaleKeyDown) return;
            ev.preventDefault();
            wheelY.current += ev.deltaY;
            if (Math.abs(wheelY.current) >= 4) {
                if (ev.deltaY > 0) {
                    wheelY.current = 0;
                    framework.stage.zoomOut();
                } else if (ev.deltaY < 0) {
                    wheelY.current = 0;
                    framework.stage.zoomIn();
                }
            }
        });

        // 快捷键缩放
        const scaleHandle = framework.events.on(HOTKEY_TYPE.scale, (i: number) => {
            if (i === 0) {
                framework.stage.zoomIn();
            } else if (i === 1) {
                framework.stage.zoomOut();
            }
        });

        return () => {
            framework.events.off(wheelHandle);
            framework.events.off(scaleHandle);
        };
    }, []);

    return null;
});

const exportPlugin: IExportPlugin = {
    type: PluginType.SYSTEM,
    sort: 3,
    name: 'hotkey-event-scale',
    render() {
        return <StageScale />;
    },
};

export default exportPlugin;
